import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getReservationLabelPattern } from '../../../reducers/userObject/selectors/settings'
import { IDateRangeInputProps } from './DateRangeInput'

function mapStateToProps() {
  const patterns = getReservationLabelPattern

  return (state: IStore): Pick<IDateRangeInputProps, 'formatDate'> => ({
    formatDate: patterns(state).formatDate,
  })
}

export default connect(mapStateToProps())
